var map = {
	"./landingVideoJson_hk_en": 39746,
	"./landingVideoJson_hk_en.js": 39746,
	"./landingVideoJson_hk_tc": 95177,
	"./landingVideoJson_hk_tc.js": 95177,
	"./landingVideoJson_my_bm": 51325,
	"./landingVideoJson_my_bm.js": 51325,
	"./landingVideoJson_my_en": 28590,
	"./landingVideoJson_my_en.js": 28590,
	"./landingVideoJson_th_en": 61160,
	"./landingVideoJson_th_en.js": 61160,
	"./landingVideoJson_th_th": 34036,
	"./landingVideoJson_th_th.js": 34036,
	"./landingVideoJson_vn_en": 2433,
	"./landingVideoJson_vn_en.js": 2433,
	"./landingVideoJson_vn_vi": 88667,
	"./landingVideoJson_vn_vi.js": 88667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29336;